import { render, staticRenderFns } from "./VmForm.vue?vue&type=template&id=7cbe4838&"
import script from "./VmForm.vue?vue&type=script&lang=js&"
export * from "./VmForm.vue?vue&type=script&lang=js&"
import style0 from "./VmForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports